import React from 'react';
import './styles.scss';

export default function Ripple(props) {
  return <span class="ripple" {...props}></span>;
}
